function SystemConfig() {
  return <div><h2>System Config</h2><p>System configuration options will go here.</p></div>;
}
export default SystemConfig; 